var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "resend-timer-wrap"
  }, [_c('div', [_vm.remaningSecond ? _c('div', [_c('span', {}, [_c('i', {
    staticClass: "fa fa-clock me-1 clock-icon"
  }), _vm._v(" Please wait "), _c('span', {
    staticClass: "resend-timer"
  }, [_vm._v(" " + _vm._s(_vm.remaningSecond) + " ")]), _vm._v(" seconds before requesting a new code. ")])]) : _vm._e()]), _c('div', {
    class: _vm.remaningSecond ? 'disable-otp' : 'resend-otp-code',
    on: {
      "click": function click($event) {
        !_vm.setSpinnerLoader && _vm.sendOtpCode();
      }
    }
  }, [_vm.setSpinnerLoader ? _c('b-spinner', {
    staticClass: "mr-3 login-highlight",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Resend Code ")], 1)]), _vm.remaningSecond ? _c('div', [_c('div', {
    staticClass: "progress",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "progress-bar bg-success",
    style: {
      width: _vm.remainingPercentage + '%'
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }